
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetobhuleshwartemple() {



    const cardData =
    {
        keyword: 'Pune to Bhuleshwar Temple Cabs',
        heading: 'Platinum24 Cabs: Pune to Bhuleshwar Temple Cabs',
        headingDescription: ' Platinum24 Cabs offers convenient Pune to Bhuleshwar Temple Cabs, ensuring a smooth and comfortable journey to the historic Shiva temple near Pune. Our fleet of hatchbacks, sedans, SUVs, and luxury cars provides safe and reliable travel options for families, groups, and devotees. With professional chauffeurs familiar with the route, we guarantee punctual pickups, flexible booking options, and stress-free travel. Whether you’re planning a same-day darshan, a family outing, or a cultural tour, Platinum24 Cabs delivers affordable fares, clean vehicles, and dependable service for your Pune to Bhuleshwar Temple trip.',

        top: 'Top Places to Visit in Igatpuri with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Bhuleshwar Temple",
    "description": "Bhuleshwar Temple, located about 45 km from Pune, is an 8th-century shrine dedicated to Lord Shiva. Built in black basalt stone, it is renowned for its intricate carvings of gods, goddesses, and mythological scenes. The temple has a unique fort-like structure, believed to have been built for protection. Devotees say Goddess Parvati danced here before her marriage with Lord Shiva. The temple’s carvings reflect both Shaiva and Shakta traditions. Bhuleshwar is Maharashtra’s architectural and spiritual marvel."
  },
  {
    "title": "Fort-like Architecture",
    "description": "Bhuleshwar Temple stands out with its unusual fort-like design, unlike typical temples. Historians believe it was constructed this way to safeguard it during invasions. The fortified walls, bastions, and gateways resemble medieval forts. Inside lies a beautifully carved sanctum dedicated to Lord Shiva. This blend of fortification and temple makes it unique. It is Bhuleshwar’s symbol of resilience and heritage."
  },
  {
    "title": "Murals and Carvings",
    "description": "The temple’s walls are adorned with ancient murals and carvings depicting episodes from Ramayana and Mahabharata. Sculptures of gods, celestial beings, and animals showcase early medieval Indian artistry. Some carvings also show Persian influences, highlighting cultural fusion. Devotees and art lovers admire the fine craftsmanship. Every stone narrates a tale of devotion. These carvings are Bhuleshwar’s timeless storytelling art."
  },
  {
    "title": "Ganpati Idol Appearance",
    "description": "A unique belief at Bhuleshwar Temple is that Lord Ganesha appears in the form of a laddu (modak). Devotees say the idol sometimes changes its shape miraculously. Pilgrims offer sweets and turmeric here as part of rituals. This phenomenon makes the temple a site of mystery and deep faith. It adds a mystical aura to the spiritual experience. Bhuleshwar is Pune’s shrine of divine wonders."
  },
  {
    "title": "Parvati and Shiva Legend",
    "description": "According to local legends, Goddess Parvati performed a dance for Lord Shiva at Bhuleshwar before their marriage in Kailash. This makes the temple spiritually significant for couples and devotees seeking marital blessings. The temple celebrates Shiv-Parvati’s union with great reverence. Pilgrims consider visiting here auspicious before weddings. The divine story enhances the temple’s cultural importance. Bhuleshwar is Maharashtra’s temple of eternal love."
  },
  {
    "title": "Hilltop Location",
    "description": "The temple is perched on a hilltop, offering panoramic views of surrounding fields and villages. The climb adds to the spiritual journey, making the darshan rewarding. The breezy environment creates a peaceful setting for meditation. During sunrise and sunset, the hilltop looks enchanting. Photographers love capturing its silhouette against the sky. The hilltop makes Bhuleshwar a scenic as well as sacred retreat."
  },
  {
    "title": "Festivals at Bhuleshwar",
    "description": "Maha Shivratri and Shravan month attract thousands of devotees to Bhuleshwar Temple. The temple is decorated with flowers, lamps, and chants of ‘Har Har Mahadev.’ Special poojas and abhisheks are performed throughout the day. Turmeric and sweets are offered as prasad. The festive atmosphere fills the hilltop with devotion. Festivals make Bhuleshwar come alive with divine energy."
  },
  {
    "title": "Yawat Region",
    "description": "Bhuleshwar is located near Yawat on the Pune–Solapur highway, making it a convenient spiritual stop. The region is dotted with farmlands, temples, and small shrines. Travelers often explore nearby villages for authentic rural experiences. Local eateries serve Maharashtrian delicacies, enhancing the trip. The peaceful countryside complements the temple visit. Yawat makes Bhuleshwar a perfect cultural and spiritual getaway."
  },
  {
    "title": "Daulat Mangal Fort Ruins",
    "description": "Nearby Bhuleshwar lie the ruins of Daulat Mangal Fort, an old Maratha stronghold. The fort area offers glimpses into history with scattered bastions and walls. It provides scenic views of valleys and fields. Trekkers and history lovers explore it along with the temple visit. The ruins narrate stories of the region’s strategic importance. Daulat Mangal Fort is Bhuleshwar’s nearby heritage site."
  },
  {
    "title": "Local Traditions & Offerings",
    "description": "Devotees at Bhuleshwar offer turmeric, sweets, and coconuts as symbols of prosperity and devotion. Local priests perform poojas and explain the temple’s legends to visitors. Folk tales about miraculous experiences are shared by villagers. Pilgrims take turmeric prasad home as a blessing. These traditions keep the temple’s culture alive. Local offerings make Bhuleshwar a temple of living faith."
  }
],



     "services": [
    {
      "name": "Pune to Bhuleshwar Temple Taxi",
      "description": "Book a reliable Pune to Bhuleshwar Temple Taxi for a smooth and spiritual journey to one of Maharashtra’s most historic hilltop temples. Whether you're planning a religious trip, a family outing, or a heritage tour, our taxis provide a peaceful and comfortable ride through the countryside. With flexible pickup points across Pune, experienced drivers familiar with the Bhuleshwar route, and clean, AC-enabled vehicles, your temple visit becomes a serene experience. Travel hassle-free and focus on your darshan while we take care of your transport needs."
    },
    {
      "name": "Bhuleshwar Temple Cab Booking Pune",
      "description": "Our Bhuleshwar Temple Cab Booking service in Pune offers a fast and user-friendly booking experience with multiple options including online, app, or phone reservations. You can choose from a variety of vehicles such as hatchbacks, sedans, SUVs, and tempo travellers based on your group size and preferences. We provide flexible scheduling and customizable routes that may include nearby sightseeing stops. Whether it’s a same-day trip or part of a larger religious tour, book your cab confidently knowing you’ll get quality service at transparent rates."
    },
    {
      "name": "Pune Bhuleshwar Temple Cabs",
      "description": "Pune Bhuleshwar Temple Cabs are specially designed for travelers seeking comfort, convenience, and spiritual fulfillment. Our drivers are well-versed with the route and nearby attractions like Malhargad Fort and Jejuri Temple. You can opt for round-trip or one-way cabs depending on your plan. Enjoy a scenic ride through the hills and get dropped right at the temple entrance. All cabs are sanitized, GPS-enabled, and come with experienced drivers who respect the sacred nature of your trip."
    },
    {
      "name": "Taxi for Bhuleshwar Temple Pune",
      "description": "Avail a dedicated Taxi for Bhuleshwar Temple from Pune and make your religious journey safe, easy, and budget-friendly. Perfect for early morning or weekend temple visits, our taxi service offers flexible departure times, on-time pickup, and comfortable rides for elderly passengers. The temple’s location on a hill requires drivers who are skilled in hilly terrains — our chauffeurs are trained for such routes, ensuring your comfort and safety throughout the trip."
    },
    {
      "name": "Pune to Bhuleshwar Temple Car Rental",
      "description": "Rent a car from Pune to Bhuleshwar Temple for a fully personalized travel experience. Our car rental options range from budget-friendly compact cars to luxury sedans and spacious SUVs, all maintained to high standards. With self-drive and chauffeur-driven options available, you can explore Bhuleshwar Temple at your own pace. Add optional services like multi-stop bookings, local guide arrangements, or refreshments onboard to enhance your religious outing."
    },
    {
      "name": "Bhuleshwar Temple Pilgrimage Taxi Pune",
      "description": "Our Bhuleshwar Temple Pilgrimage Taxi Service in Pune is tailored for spiritual travelers who seek a peaceful, comfortable ride to this ancient Shiva temple. With early morning pickup slots, knowledgeable drivers, and optional add-ons like temple visit coordination or group travel support, this service is ideal for devotees. Our cabs are equipped with cushions, water bottles, and music systems to make your sacred trip even more pleasant and enriching."
    },
    {
      "name": "Affordable Bhuleshwar Temple Tour Cabs Pune",
      "description": "Get the best value for your spiritual journey with our Affordable Bhuleshwar Temple Tour Cabs from Pune. Designed for families, senior citizens, and budget-conscious pilgrims, these cabs offer great service without compromising on quality. Transparent pricing, no surge charges, and combo packages that include Jejuri, Malhargad, or Saswad visits make these tours cost-effective and spiritually rewarding."
    },
    {
      "name": "Pune Bhuleshwar Temple Private Taxi",
      "description": "Choose a Pune Bhuleshwar Temple Private Taxi for privacy, comfort, and total convenience. Avoid the crowd and travel with your loved ones in a sanitized, AC vehicle of your choice. Enjoy dedicated service with no ride-sharing and the freedom to take breaks or stop for food en route. Drivers are courteous, punctual, and trained to make religious trips respectful and stress-free."
    },
    {
      "name": "Pune to Bhuleshwar Temple Taxi Fare",
      "description": "Our Pune to Bhuleshwar Temple Taxi Fare is competitively priced and offers full transparency. Pricing includes fuel, tolls, driver allowance, and taxes — with no hidden fees. Get instant fare estimates while booking and choose from multiple pricing tiers based on vehicle category. We also offer discounts for round trips, senior citizens, and repeat bookings. Pay online, via UPI, or in cash after the ride."
    },
    {
      "name": "Bhuleshwar Temple Taxi Packages Pune",
      "description": "Choose from our Bhuleshwar Temple Taxi Packages starting from half-day trips to full-day religious circuits. Packages include round-trip travel, sightseeing nearby temples or forts, waiting time at the temple, and additional stops on request. These curated packages are ideal for families or tour groups wanting a hassle-free temple tour with a fixed budget and time-efficient itinerary."
    },
    {
      "name": "Pune Bhuleshwar Temple One Way Taxi",
      "description": "Opt for a Pune to Bhuleshwar Temple One Way Taxi if you plan to stay near the temple or continue your journey elsewhere. Ideal for pilgrims who wish to return by other means or for outstation visitors planning onward travel. Our one-way cabs are affordable and available across Pune city including airport, railway station, and major residential areas."
    },
    {
      "name": "Taxi Service Pune to Bhuleshwar Temple",
      "description": "Our all-inclusive Taxi Service from Pune to Bhuleshwar Temple ensures a smooth, punctual, and spiritual travel experience. Enjoy door-to-door pickup, scenic countryside routes, and dedicated customer support. Vehicles are available on-demand or through advance booking for early morning temple visits, weekend trips, or festive pilgrimages. Drivers follow COVID-safe protocols and respect temple etiquettes, ensuring a serene journey."
    },
    {
      "name": "Bhuleshwar Temple Taxi with Driver Pune",
      "description": "Book a Bhuleshwar Temple Taxi with Driver from Pune for a relaxed and guided journey. Our professional drivers are not only experienced but also courteous and respectful of religious sentiments. They’ll ensure timely pickups, comfortable ride quality, and smooth navigation to the hilltop temple. Perfect for elderly travelers, families, or first-time visitors to Bhuleshwar."
    },
    {
      "name": "Pune to Bhuleshwar Temple Cab Charges",
      "description": "Get complete clarity on Pune to Bhuleshwar Temple Cab Charges before you travel. Our rate card includes base fare, AC charges, waiting time, and parking if applicable. Choose the best fit from our range of economy to premium vehicles based on your comfort and budget. Additional discounts are available on group travel and off-peak hours."
    },
    {
      "name": "Bhuleshwar Temple Cab Service Pune",
      "description": "Our Bhuleshwar Temple Cab Service in Pune offers reliable, flexible, and professional travel to one of Maharashtra's iconic spiritual destinations. Operating 365 days a year, our fleet caters to families, tourists, and solo devotees alike. Book instantly and travel in clean, comfortable, and chauffeur-driven cabs that prioritize your safety and spiritual peace."
    }
  ],
  "tableData": [
    ["Pune to Bhuleshwar Temple Taxi", "Bhuleshwar Temple Cab Booking Pune"],
    ["Pune Bhuleshwar Temple Cabs", "Taxi for Bhuleshwar Temple Pune"],
    ["Pune to Bhuleshwar Temple Car Rental", "Bhuleshwar Temple Pilgrimage Taxi Pune"],
    ["Affordable Bhuleshwar Temple Tour Cabs Pune", "Pune Bhuleshwar Temple Private Taxi"],
    ["Pune to Bhuleshwar Temple Taxi Fare", "Bhuleshwar Temple Taxi Packages Pune"],
    ["Pune Bhuleshwar Temple One Way Taxi", "Taxi Service Pune to Bhuleshwar Temple"],
    ["Bhuleshwar Temple Taxi with Driver Pune", "Pune to Bhuleshwar Temple Cab Charges"],
    ["Bhuleshwar Temple Cab Service Pune", "—"]
  ],


      "whychoose": [
    {
      "WhyChooseheading": "Comfortable Pune to Bhuleshwar Temple Cab Service",
      "WhyChoosedescription": "Platinum24 Cabs offers reliable and convenient taxi services from Pune to the historic Bhuleshwar Temple."
    },
    {
      "WhyChooseheading": "Experienced Drivers Familiar with the Route",
      "WhyChoosedescription": "Our drivers know the Pune to Bhuleshwar Temple route well, ensuring a smooth and timely journey."
    },
    {
      "WhyChooseheading": "Clean, Sanitized, and Air-Conditioned Vehicles",
      "WhyChoosedescription": "Enjoy a safe and pleasant ride in our regularly sanitized and well-maintained cabs."
    },
    {
      "WhyChooseheading": "Flexible One-Way and Round Trip Options",
      "WhyChoosedescription": "Choose travel packages based on your preference—be it a short visit or a day-long pilgrimage."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "Get all-inclusive fares with no hidden costs—covering fuel, tolls, and driver allowances."
    },
    {
      "WhyChooseheading": "24/7 Booking and Customer Support",
      "WhyChoosedescription": "Book your cab anytime with the help of our dedicated customer support team."
    },
    {
      "WhyChooseheading": "Ideal for Pilgrimage, Family Trips, and Group Travel",
      "WhyChoosedescription": "Our cab services suit all kinds of travelers visiting Bhuleshwar Temple from Pune."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options Available",
      "WhyChoosedescription": "Pick from hatchbacks, sedans, SUVs, or tempo travellers depending on your group size and comfort needs."
    }
  ]






































    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs provide cab services from Pune to Bhuleshwar Temple?',
        answer: 'Yes, Platinum24 Cabs offers comfortable and convenient cab services for travel from Pune to Bhuleshwar Temple.',
    },
    {
        question: 'How do I book a cab from Pune to Bhuleshwar Temple with Platinum24 Cabs?',
        answer: 'You can book your cab easily through our website, mobile app, or by calling our customer support.',
    },
    {
        question: 'What types of vehicles are available for the Pune to Bhuleshwar Temple route?',
        answer: 'We offer a range of vehicles including hatchbacks, sedans, SUVs, and tempo travellers to suit different group sizes and preferences.',
    },
    {
        question: 'How far is Bhuleshwar Temple from Pune and how long is the drive?',
        answer: 'Bhuleshwar Temple is approximately 50 km from Pune, and the drive typically takes around 1.5 to 2 hours depending on traffic.',
    },
    {
        question: 'Can I book a round trip cab from Pune to Bhuleshwar Temple?',
        answer: 'Yes, we offer round-trip cab services with flexible scheduling for your visit to Bhuleshwar Temple.',
    },
    {
        question: 'Are the drivers familiar with the route to Bhuleshwar Temple?',
        answer: 'Absolutely. Our drivers are experienced and well-acquainted with the route to Bhuleshwar Temple, ensuring a safe and smooth journey.',
    },
    {
        question: 'What is included in the fare for the Pune to Bhuleshwar Temple cab service?',
        answer: 'The fare includes driver charges, fuel, tolls, and taxes. Extra charges may apply for additional stops or extended waiting time.',
    },
    {
        question: 'Are the cabs sanitized and safe for temple trips?',
        answer: 'Yes, all vehicles are thoroughly sanitized before each trip and our drivers follow strict safety and hygiene protocols.',
    },
    {
        question: 'Can I schedule an early morning pickup for a temple visit?',
        answer: 'Yes, you can pre-schedule your pickup for any time of the day, including early morning temple visits.',
    },
    {
        question: 'Do you offer special packages for religious tours like Bhuleshwar Temple?',
        answer: 'Yes, we have customizable pilgrimage tour packages which include Bhuleshwar Temple and other nearby spiritual sites.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Mahesh Shinde',
        feedback: 'The trip to Bhuleshwar Temple with Platinum24 Cabs was peaceful and well-managed. The driver knew the route and timing perfectly.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Sunita Jagtap',
        feedback: 'Booked a cab to Bhuleshwar Temple from Pune — very punctual, clean vehicle, and smooth ride. Highly satisfied!',
        rating: 5,
    },
];





















































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];








const bhuleshwarTempleTaxiSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Affordable and reliable taxi service from Pune to Bhuleshwar Temple for pilgrimage trips, one-way rides, and private bookings with experienced drivers.",
  "areaServed": [
    {
      "@type": "City",
      "name": "Pune"
    },
    {
      "@type": "Place",
      "name": "Bhuleshwar Temple"
    }
  ],
  "serviceType": [
    "Pune to Bhuleshwar Temple Taxi",
    "Bhuleshwar Temple Cab Booking Pune",
    "Pune Bhuleshwar Temple Cabs",
    "Taxi for Bhuleshwar Temple Pune",
    "Pune to Bhuleshwar Temple Car Rental",
    "Bhuleshwar Temple Pilgrimage Taxi Pune",
    "Affordable Bhuleshwar Temple Tour Cabs Pune",
    "Pune Bhuleshwar Temple Private Taxi",
    "Pune to Bhuleshwar Temple Taxi Fare",
    "Bhuleshwar Temple Taxi Packages Pune",
    "Pune Bhuleshwar Temple One Way Taxi",
    "Taxi Service Pune to Bhuleshwar Temple",
    "Bhuleshwar Temple Taxi with Driver Pune",
    "Pune to Bhuleshwar Temple Cab Charges",
    "Bhuleshwar Temple Cab Service Pune"
  ],
  "telephone": "+91-XXXXXXXXXX"
};





    return (
        <div>


<Helmet>
  <title>Pune to Bhuleshwar Temple Taxi Service | Pilgrimage Cab Booking Pune</title>
  <meta
    name="description"
    content="Affordable and reliable taxi service from Pune to Bhuleshwar Temple for pilgrimage trips, one-way rides, and private bookings with experienced drivers."
  />
  <meta
    name="keywords"
    content="Pune to Bhuleshwar Temple Taxi, Bhuleshwar Temple Cab Booking Pune, Pune Bhuleshwar Temple Cabs, Taxi for Bhuleshwar Temple Pune, Pune to Bhuleshwar Temple Car Rental, Bhuleshwar Temple Pilgrimage Taxi Pune, Affordable Bhuleshwar Temple Tour Cabs Pune, Pune Bhuleshwar Temple Private Taxi, Pune to Bhuleshwar Temple Taxi Fare, Bhuleshwar Temple Taxi Packages Pune, Pune Bhuleshwar Temple One Way Taxi, Taxi Service Pune to Bhuleshwar Temple, Bhuleshwar Temple Taxi with Driver Pune, Pune to Bhuleshwar Temple Cab Charges, Bhuleshwar Temple Cab Service Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(bhuleshwarTempleTaxiSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/58.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetobhuleshwartemple;